import { Role } from '@/api/types'

export default [
    {
        name: 'company_settings',
        path: '/company/settings',
        redirect: { name: 'company_settings_general' },
        meta: {
            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
        },
        component: () => import(/* webpackChunkName: "company_settings" */ '../../views/Company/Settings.vue'),
        children: [
            {
                name: 'company_settings_general',
                path: 'general',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_general" */ '../../views/Company/Settings/General.vue'),
            },
            {
                name: 'company_settings_branding',
                path: 'branding',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_branding" */ '../../views/Company/Settings/Branding.vue'),
            },
            {
                name: 'company_settings_pipelines',
                path: 'pipelines',
                redirect: { name: 'company_settings_pipelines_edit' },
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_pipelines" */ '../../views/Company/Settings/Pipelines/Pipelines.vue'),
                children: [
                    {
                        name: 'company_settings_pipelines_edit',
                        path: 'edit',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_pipelines_edit" */ '../../views/Company/Settings/Pipelines/Edit.vue'),
                    },
                    {
                        name: 'company_settings_pipelines_operating_zones',
                        path: 'operating-zones',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_pipelines_operating_zones" */ '../../views/Company/Settings/Pipelines/OperatingZones.vue'),
                    },
                    {
                        name: 'company_settings_pipelines_channels',
                        path: 'channels',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_pipelines_channels" */ '../../views/Company/Settings/Pipelines/Channels.vue'),
                    },
                    {
                        name: 'company_settings_pipelines_connections_incoming',
                        path: 'connections-outgoing',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_pipelines_connections_incoming" */ '../../views/Company/Settings/Pipelines/ConnectionsIncoming.vue'),
                    },
                    {
                        name: 'company_settings_pipelines_connections_outgoing',
                        path: 'connections-incoming',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_pipelines_connections_outgoing" */ '../../views/Company/Settings/Pipelines/ConnectionsOutgoing.vue'),
                    },
                ],
            },
            {
                name: 'company_settings_statuses',
                path: 'statuses',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_statuses" */ '../../views/Company/Settings/Statuses/Statuses.vue'),
            },
            {
                name: 'company_settings_sources',
                path: 'sources',
                redirect: { name: 'company_settings_sources_list' },
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_sources" */ '../../views/Company/Settings/Sources.vue'),
                children: [
                    {
                        name: 'company_settings_sources_list',
                        path: 'list',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_sources_list" */ '../../views/Company/Settings/Sources/List.vue'),
                    },
                    {
                        name: 'company_settings_sources_create',
                        path: 'create',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_sources_create" */ '../../views/Company/Settings/Sources/Create.vue'),
                    },
                    {
                        name: 'company_settings_sources_edit_incoming',
                        path: 'edit/incoming/:referralNodeId',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_sources_edit_incoming" */ '../../views/Company/Settings/Sources/Edit/Incoming.vue'),
                        props: true,
                    },
                    {
                        name: 'company_settings_sources_edit_outgoing',
                        path: 'edit/outgoing/:referralNodeId',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_sources_edit_outgoing" */ '../../views/Company/Settings/Sources/Edit/Outgoing.vue'),
                        props: true,
                    },
                ],
            },
            {
                name: 'company_settings_users',
                path: 'users',
                redirect: { name: 'company_settings_users_list' },
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_users" */ '../../views/Company/Settings/Users.vue'),
                children: [
                    {
                        name: 'company_settings_users_list',
                        path: 'list',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_users_list" */ '../../views/Company/Settings/Users/List.vue'),
                    },
                    {
                        name: 'company_settings_users_create',
                        path: 'create',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_users_create" */ '../../views/Company/Settings/Users/Create.vue'),
                    },
                    {
                        name: 'company_settings_users_edit',
                        path: 'edit/:userId',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_users_edit" */ '../../views/Company/Settings/Users/Edit.vue'),
                        props: true,
                    },
                    {
                        name: 'company_settings_users_create_from_realworks',
                        path: 'create_from_realworks',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_users_create_from_realworks" */ '../../views/Company/Settings/Users/CreateFromRealworks.vue'),
                    },
                ],
            },
            {
                name: 'company_settings_realworks_credentials',
                path: 'realworks_credentials',
                redirect: { name: 'company_settings_realworks_credentials_list' },
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_realworks_credentials" */ '../../views/Company/Settings/RealworksCredentials.vue'),
                children: [
                    {
                        name: 'company_settings_realworks_credentials_list',
                        path: 'list',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_realworks_credentials_list" */ '../../views/Company/Settings/RealworksCredentials/List.vue'),
                    },
                    {
                        name: 'company_settings_realworks_credentials_create',
                        path: 'create',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_realworks_credentials_create" */ '../../views/Company/Settings/RealworksCredentials/Create.vue'),
                    },
                    {
                        name: 'company_settings_realworks_credentials_edit',
                        path: 'edit/:credentialsId',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_realworks_credentials_edit" */ '../../views/Company/Settings/RealworksCredentials/Edit.vue'),
                        props: true,
                    },
                ],
            },
            {
                name: 'company_settings_teams',
                path: 'teams',
                redirect: { name: 'company_settings_teams_list' },
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_teams" */ '../../views/Company/Settings/Teams.vue'),
                children: [
                    {
                        name: 'company_settings_teams_list',
                        path: 'list',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_teams_list" */ '../../views/Company/Settings/Teams/List.vue'),
                    },
                    {
                        name: 'company_settings_teams_create',
                        path: 'create',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_teams_create" */ '../../views/Company/Settings/Teams/Create.vue'),
                    },
                    {
                        name: 'company_settings_teams_edit',
                        path: 'edit/:teamId',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_teams_edit" */ '../../views/Company/Settings/Teams/Edit.vue'),
                        props: true,
                    },
                ],
            },
            {
                name: 'company_settings_smart_marketing',
                path: 'smart_marketing',
                redirect: { name: 'company_settings_smart_marketing_general' },
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_smart_marketing" */ '../../views/Company/Settings/SmartMarketing.vue'),
                children: [
                    {
                        name: 'company_settings_smart_marketing_general',
                        path: '',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_smart_marketing_general" */ '../../views/Company/Settings/SmartMarketing/General.vue'),
                    },
                    {
                        name: 'company_settings_smart_marketing_contacts',
                        path: 'contacts',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_smart_marketing_contacts" */ '../../views/Company/Settings/SmartMarketing/Contacts.vue'),
                    },
                    {
                        name: 'company_settings_smart_marketing_event',
                        path: 'event_tracking',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_smart_marketing_event" */ '../../views/Company/Settings/SmartMarketing/EventTracking.vue'),
                    },
                    {
                        name: 'company_settings_smart_marketing_teams',
                        path: 'teams',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_smart_marketing_teams" */ '../../views/Company/Settings/SmartMarketing/DefaultTeams.vue'),
                    },
                    {
                        name: 'company_settings_smart_marketing_webhooks',
                        path: 'webhooks',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_smart_marketing_webhooks" */ '../../views/Company/Settings/SmartMarketing/Webhooks.vue'),
                    },
                    {
                        name: 'company_settings_smart_marketing_realworks',
                        path: 'realworks',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_smart_marketing_realworks" */ '../../views/Company/Settings/SmartMarketing/Realworks.vue'),
                    },
                ],
            },
            {
                name: 'company_settings_webhook_create',
                path: 'webhook/create',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_webhook_create" */ '../../views/Company/Settings/Webhook/Create.vue'),
            },
            {
                name: 'company_settings_webhook_edit',
                path: 'webhook/:id',
                props: true,
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_webhook_edit" */ '../../views/Company/Settings/Webhook/Edit.vue'),
            },
            {
                name: 'company_settings_emma_widget',
                path: 'emma_widget',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_emma_widget" */ '../../views/Company/Settings/EmmaWidget.vue'),
            },
            {
                name: 'company_settings_emma_chat',
                path: 'emma_chat',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_emma_chat" */ '../../views/Company/Settings/EmmaChat.vue'),
            },
            {
                name: 'company_settings_emma_urls',
                path: 'emma_urls',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_emma_urls" */ '../../views/Company/Settings/EmmaUrls.vue'),
            },
            {
                name: 'company_settings_valuation_settings',
                path: 'emma_valuation',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_emma_urls" */ '../../views/Company/Settings/ValuationSettings.vue'),
            },
            {
                name: 'company_settings_emma_avatar',
                path: 'emma_avatar',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_emma_avatar" */ '../../views/Company/Settings/EmmaAvatar.vue'),
            },
            {
                name: 'company_settings_emma_information_flow',
                path: 'emma_information',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_emma_information_flow" */ '../../views/Company/Settings/EmmaInformationFlow.vue'),
            },
            {
                name: 'company_settings_checklist_settings',
                path: 'checklist',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_checklist_settings" */ '../../views/Company/Settings/Checklist.vue'),
            },
            {
                name: 'company_settings_gamification',
                path: 'gamification',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_checklist_settings" */ '../../views/Company/Settings/Gamification.vue'),
            },
            {
                name: 'company_settings_orders',
                path: 'orders',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_orders" */ '../../views/Company/Settings/Orders/Orders.vue'),
            },
            {
                name: 'company_settings_shares_list',
                path: 'shares',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_shares_list" */ '../../views/Company/Settings/Shares/List.vue'),
            },
            {
                name: 'company_settings_emma_direct_mail',
                path: 'emma_direct_mail',
                redirect: { name: 'company_settings_emma_direct_mail_printable_documents' },
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_emma_direct_mail" */ '../../views/Company/Settings/EmmaDirectMail.vue'),
                children: [
                    {
                        name: 'company_settings_emma_direct_mail_printable_documents',
                        path: 'printable_documents',
                        redirect: { name: 'company_settings_emma_direct_mail_printable_documents_list' },
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_emma_direct_mail_printable_documents" */ '../../views/Company/Settings/EmmaDirectMail/PrintableDocuments.vue'),
                        children: [
                            {
                                name: 'company_settings_emma_direct_mail_printable_documents_list',
                                path: 'list',
                                meta: {
                                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                                },
                                component: () => import(/* webpackChunkName: "company_settings_emma_direct_mail_printable_documents_list" */ '../../views/Company/Settings/EmmaDirectMail/PrintableDocuments/List.vue'),
                            },
                            {
                                name: 'company_settings_emma_direct_mail_printable_documents_create',
                                path: 'create',
                                meta: {
                                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                                },
                                component: () => import(/* webpackChunkName: "company_settings_emma_direct_mail_printable_documents_create" */ '../../views/Company/Settings/EmmaDirectMail/PrintableDocuments/Create.vue'),
                            },
                            {
                                name: 'company_settings_emma_direct_mail_printable_documents_edit',
                                path: 'edit/:printableDocumentId',
                                meta: {
                                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                                },
                                component: () => import(/* webpackChunkName: "company_settings_emma_direct_mail_printable_documents_edit" */ '../../views/Company/Settings/EmmaDirectMail/PrintableDocuments/Edit.vue'),
                                props: true,
                            },
                        ],
                    },
                    {
                        name: 'company_settings_emma_direct_mail_costs',
                        path: 'costs',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_emma_direct_mail_costs" */ '../../views/Company/Settings/EmmaDirectMail/Costs.vue'),
                    },
                    {
                        name: 'company_settings_emma_direct_mail_printed_documents',
                        path: 'printed_documents',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_emma_direct_mail_printed_documents" */ '../../views/Company/Settings/EmmaDirectMail/PrintedDocuments.vue'),
                    },
                ],
            },
            {
                name: 'projects_list',
                path: '/projects',
                meta: {
                    requiredRole: Role.BRANCH_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "projects_list" */ '../../views/Projects/List.vue'),
            },
            {
                name: 'projects_create',
                path: '/projects/create',
                meta: {
                    requiredRole: Role.BRANCH_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "projects_create" */ '../../views/Projects/Create.vue'),
            },
            {
                name: 'projects_detail',
                path: '/projects/:projectId',
                props: true,
                meta: {
                    requiredRole: Role.BRANCH_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "projects_detail" */ '../../views/Projects/Detail.vue'),
            },
            {
                name: 'company_settings_narrowcasting',
                path: 'narrowcasting',
                component: () => import(/* webpackChunkName: "company_settings_narrowcasting" */ '../../views/Company/Settings/Narrowcasting.vue'),
                redirect: { name: 'company_settings_narrowcasting_offices' },
                meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                children: [
                    {
                        name: 'company_settings_narrowcasting_screens',
                        path: 'screens',
                        component: () => import(/* webpackChunkName: "company_settings_narrowcasting_screens" */ '../../views/Company/Settings/Narrowcasting/Screens.vue'),
                        redirect: { name: 'company_settings_narrowcasting_screens_list' },
                        meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                        children: [
                            {
                                name: 'company_settings_narrowcasting_screens_list',
                                path: '',
                                component: () => import(/* webpackChunkName: "company_settings_narrowcasting_screens_list" */ '../../views/Company/Settings/Narrowcasting/Screens/List.vue'),
                                meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                            },
                            {
                                name: 'company_settings_narrowcasting_screens_create',
                                path: 'create',
                                component: () => import(/* webpackChunkName: "company_settings_narrowcasting_screens_create" */ '../../views/Company/Settings/Narrowcasting/Screens/Create.vue'),
                                meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                            },
                            {
                                name: 'company_settings_narrowcasting_screens_edit',
                                path: ':screenId',
                                props: true,
                                component: () => import(/* webpackChunkName: "company_settings_narrowcasting_screens_edit" */ '../../views/Company/Settings/Narrowcasting/Screens/Edit.vue'),
                                meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                            },
                        ],
                    },
                    {
                        name: 'company_settings_narrowcasting_offices',
                        path: 'offices',
                        component: () => import(/* webpackChunkName: "company_settings_narrowcasting_offices" */ '../../views/Company/Settings/Narrowcasting/Offices.vue'),
                        redirect: { name: 'company_settings_narrowcasting_offices_list' },
                        meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                        children: [
                            {
                                name: 'company_settings_narrowcasting_offices_list',
                                path: '',
                                component: () => import(/* webpackChunkName: "company_settings_narrowcasting_offices_list" */ '../../views/Company/Settings/Narrowcasting/Offices/List.vue'),
                                meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                            },
                            {
                                name: 'company_settings_narrowcasting_offices_create',
                                path: 'create',
                                component: () => import(/* webpackChunkName: "company_settings_narrowcasting_offices_create" */ '../../views/Company/Settings/Narrowcasting/Offices/Create.vue'),
                                meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                            },
                            {
                                name: 'company_settings_narrowcasting_offices_edit',
                                path: ':officeId',
                                props: true,
                                component: () => import(/* webpackChunkName: "company_settings_narrowcasting_offices_edit" */ '../../views/Company/Settings/Narrowcasting/Offices/Edit.vue'),
                                meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                            },
                        ],
                    },
                    {
                        name: 'company_settings_narrowcasting_collections',
                        path: 'collections',
                        component: () => import(/* webpackChunkName: "company_settings_narrowcasting_collections" */ '../../views/Company/Settings/Narrowcasting/Collections.vue'),
                        redirect: { name: 'company_settings_narrowcasting_collections_list' },
                        meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                        children: [
                            {
                                name: 'company_settings_narrowcasting_collections_list',
                                path: '',
                                component: () => import(/* webpackChunkName: "company_settings_narrowcasting_collections_list" */ '../../views/Company/Settings/Narrowcasting/Collections/List.vue'),
                                meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                            },
                            {
                                name: 'company_settings_narrowcasting_collections_create',
                                path: 'create',
                                component: () => import(/* webpackChunkName: "company_settings_narrowcasting_collections_create" */ '../../views/Company/Settings/Narrowcasting/Collections/Create.vue'),
                                meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                            },
                            {
                                name: 'company_settings_narrowcasting_collections_edit',
                                path: ':collectionId',
                                props: true,
                                component: () => import(/* webpackChunkName: "company_settings_narrowcasting_collections_edit" */ '../../views/Company/Settings/Narrowcasting/Collections/Edit.vue'),
                                meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                            },
                        ],
                    },
                    {
                        name: 'company_settings_narrowcasting_scheduled_collections',
                        path: 'scheduled_collections',
                        component: () => import(/* webpackChunkName: "company_settings_narrowcasting_scheduled_collections" */ '../../views/Company/Settings/Narrowcasting/ScheduledCollections.vue'),
                        redirect: { name: 'company_settings_narrowcasting_scheduled_collections_list' },
                        meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                        children: [
                            {
                                name: 'company_settings_narrowcasting_scheduled_collections_list',
                                path: '',
                                component: () => import(/* webpackChunkName: "company_settings_narrowcasting_scheduled_collections_list" */ '../../views/Company/Settings/Narrowcasting/ScheduledCollections/List.vue'),
                                meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                            },
                            {
                                name: 'company_settings_narrowcasting_scheduled_collections_create',
                                path: 'create',
                                component: () => import(/* webpackChunkName: "company_settings_narrowcasting_scheduled_collections_create" */ '../../views/Company/Settings/Narrowcasting/ScheduledCollections/Create.vue'),
                                meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                            },
                            {
                                name: 'company_settings_narrowcasting_scheduled_collections_edit',
                                path: ':scheduledCollectionId',
                                props: true,
                                component: () => import(/* webpackChunkName: "company_settings_narrowcasting_scheduled_collections_edit" */ '../../views/Company/Settings/Narrowcasting/ScheduledCollections/Edit.vue'),
                                meta: { requiredRole: Role.COMPANY_MANAGER, noBackground: false },
                            },
                        ],
                    },
                ],
            },

            {
                name: 'company_settings_typeform',
                path: 'typeform',
                redirect: { name: 'company_settings_typeform_general' },
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_typeform" */ '../../views/Company/Settings/Typeform.vue'),
                children: [
                    {
                        name: 'company_settings_typeform_general',
                        path: 'general',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_typeform_general" */ '../../views/Company/Settings/Typeform/General.vue'),
                    },
                    {
                        name: 'company_settings_customer_portal',
                        path: 'customerportal',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_customer_portal" */ '../../views/Company/Settings/Typeform/CustomerPortal.vue'),
                    },
                    {
                        name: 'company_settings_typeform_theme',
                        path: 'theme',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_typeform_theme" */ '../../views/Company/Settings/Typeform/Theme.vue'),
                    },
                    {
                        name: 'company_settings_typeform_forms',
                        path: 'forms',
                        redirect: { name: 'company_settings_typeform_forms_list' },
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_typeform_forms" */ '../../views/Company/Settings/Typeform/Forms.vue'),
                        children: [
                            {
                                name: 'company_settings_typeform_forms_list',
                                path: 'list',
                                meta: {
                                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                                },
                                component: () => import(/* webpackChunkName: "company_settings_typeform_forms_list" */ '../../views/Company/Settings/Typeform/Forms/List.vue'),
                            },
                            {
                                name: 'company_settings_typeform_forms_detail',
                                path: 'detail/:formId',
                                meta: {
                                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                                },
                                component: () => import(/* webpackChunkName: "company_settings_typeform_forms_detail" */ '../../views/Company/Settings/Typeform/Forms/Detail.vue'),
                                props: true,
                            },
                        ],
                    },
                ],
            },

            {
                name: 'company_settings_reports',
                path: 'reports',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_reports" */ '../../views/Company/Settings/Reports.vue'),
            },

            {
                name: 'company_settings_documents',
                path: 'documents',
                meta: {
                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                },
                component: () => import(/* webpackChunkName: "company_settings_documents" */ '../../views/Company/Settings/Documents.vue'),
            },
            {
                name: 'company_settings_virtual_colleague',
                path: 'virtual-colleague',
                redirect: { name: 'company_settings_virtual_colleague_general' },
                component: () => import(/* webpackChunkName: "company_settings_virtual_colleague" */ '../../views/Company/Settings/VirtualColleague/VirtualColleague.vue'),
                children: [
                    {
                        name: 'company_settings_virtual_colleague_general',
                        path: 'general',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_virtual_colleague_general" */ '../../views/Company/Settings/VirtualColleague/General.vue'),
                    },
                    {
                        name: 'company_settings_virtual_colleague_triggered_referral',
                        path: 'triggered-referrals',
                        redirect: { name: 'company_settings_virtual_colleague_triggered_referral_list' },
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_virtual_colleague_triggered_referral" */ '../../views/Company/Settings/VirtualColleague/TriggeredReferrals/TriggeredReferral.vue'),
                        children: [
                            {
                                name: 'company_settings_virtual_colleague_triggered_referral_list',
                                path: 'list',
                                meta: {
                                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                                },
                                component: () => import(/* webpackChunkName: "company_settings_virtual_colleague_triggered_referrals_list" */ '../../views/Company/Settings/VirtualColleague/TriggeredReferrals/List.vue'),
                            },
                            {
                                name: 'company_settings_virtual_colleague_triggered_referral_create',
                                path: 'create',
                                meta: {
                                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                                },
                                component: () => import(/* webpackChunkName: "company_settings_virtual_colleague_triggered_referrals_create" */ '../../views/Company/Settings/VirtualColleague/TriggeredReferrals/Create.vue'),
                            },
                            {
                                name: 'company_settings_virtual_colleague_triggered_referral_detail',
                                path: ':triggeredReferralId',
                                meta: {
                                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                                },
                                component: () => import(/* webpackChunkName: "company_settings_virtual_colleague_triggered_referrals_detail" */ '../../views/Company/Settings/VirtualColleague/TriggeredReferrals/Detail.vue'),
                                props: true,
                            },
                        ],
                    },
                    {
                        name: 'company_settings_virtual_colleague_triggered_action',
                        path: 'triggered-actions',
                        redirect: { name: 'company_settings_virtual_colleague_triggered_actions_list' },
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_virtual_colleague_triggered_action" */ '../../views/Company/Settings/VirtualColleague/TriggeredActions/TriggeredAction.vue'),
                        children: [
                            {
                                name: 'company_settings_virtual_colleague_triggered_actions_list',
                                path: 'list',
                                meta: {
                                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                                },
                                component: () => import(/* webpackChunkName: "company_settings_virtual_colleague_triggered_actions_list" */ '../../views/Company/Settings/VirtualColleague/TriggeredActions/List.vue'),
                            },
                            {
                                name: 'company_settings_virtual_colleague_triggered_actions_create',
                                path: 'create',
                                meta: {
                                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                                },
                                component: () => import(/* webpackChunkName: "company_settings_virtual_colleague_triggered_actions_create" */ '../../views/Company/Settings/VirtualColleague/TriggeredActions/Create.vue'),
                            },
                            {
                                name: 'company_settings_virtual_colleague_triggered_actions_detail',
                                path: ':triggeredActionId',
                                meta: {
                                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                                },
                                component: () => import(/* webpackChunkName: "company_settings_virtual_colleague_triggered_actions_detail" */ '../../views/Company/Settings/VirtualColleague/TriggeredActions/Detail.vue'),
                                props: true,
                            },
                        ],
                    },
                    {
                        name: 'company_settings_virtual_colleague_realworks_status_rules',
                        path: 'realworks_status_rules',
                        redirect: { name: 'company_settings_virtual_colleague_realworks_status_rules_list' },
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_virtual_colleague_realworks_status_rules" */ '../../views/Company/Settings/VirtualColleague/RealworksStatusRules/RealworksStatusRule.vue'),
                        children: [
                            {
                                name: 'company_settings_virtual_colleague_realworks_status_rules_list',
                                path: 'list',
                                meta: {
                                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                                },
                                component: () => import(/* webpackChunkName: "company_settings_virtual_colleague_realworks_status_rules_list" */ '../../views/Company/Settings/VirtualColleague/RealworksStatusRules/List.vue'),
                            },
                            {
                                name: 'company_settings_virtual_colleague_realworks_status_rules_create',
                                path: 'create',
                                meta: {
                                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                                },
                                component: () => import(/* webpackChunkName: "company_settings_virtual_colleague_realworks_status_rules_create" */ '../../views/Company/Settings/VirtualColleague/RealworksStatusRules/Create.vue'),
                            },
                            {
                                name: 'company_settings_virtual_colleague_realworks_status_rules_detail',
                                path: 'detail/:realworksStatusRuleId',
                                meta: {
                                    requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                                },
                                component: () => import(/* webpackChunkName: "company_settings_virtual_colleague_realworks_status_rules_edit" */ '../../views/Company/Settings/VirtualColleague/RealworksStatusRules/Detail.vue'),
                                props: true,
                            },
                        ],
                    },
                    {
                        name: 'company_settings_auto_close_settings',
                        path: 'auto_close',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_auto_close_settings" */ '../../views/Company/Settings/VirtualColleague/AutoClose/AutoClose.vue'),
                    },
                    {
                        name: 'company_settings_turnover',
                        path: 'turnover',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                        component: () => import(/* webpackChunkName: "company_settings_turnover" */ '../../views/Company/Settings/VirtualColleague/Turnover/Turnover.vue'),
                    },
                    {
                        name: 'one_settings_virtual_colleague_ai',
                        path: 'ai',
                        meta: {
                            requiredRole: Role.COMPANY_MANAGER, noBackground: false,
                        },
                    },
                ],
            },
        ],
    },
]
